import { sGetFromEngagementTools } from './shared.min.js';

const petrolPrices = (function () {
	let sortedPetrolPriceData = [],
		displayData = [],
		isAuthenticatedUser = document.getElementById('petrol-prices-logged-status').dataset.loggedInStatus,
		selectedFuelType,
		selectedPostCode,
		requestSource = 'SearchForm',
		geoLat = null,
		geoLong = null,
		geoLocation = null,
		geoLocationError = false,
		radius = 5,
		sortType = 'price',
		APIURLS = document.getElementById('petrol-prices-api'),
		apiSubKey = APIURLS.dataset.apisubkey,
		priceStatisticsUrl = APIURLS.dataset.apipricestatistics,
		petrolPricesUrl = APIURLS.dataset.apipetrolprices;
	const container = document.querySelector('.petrol-prices'),
		getLocationButton = document.getElementById('getLocationButton'),
		openFilters = document.getElementById('openFilters'),
		closedFilters = document.getElementById('closedFilters'),
		filter = document.getElementById('filter'),
		parent = document.getElementById('petrol-prices-results'),
		viewMoreButton = document.getElementById('expandSearchDistance'),
		shareButton = document.getElementById('share-button'),
		resetValues = () => {
			geoLocation = '';
			geoLat = '';
			geoLong = '';
			selectedPostCode = '';
			geoLocationError = false;
		};

	if (isAuthenticatedUser === 'False') {
		isAuthenticatedUser = false;
	} else if (isAuthenticatedUser === 'True') {
		isAuthenticatedUser = true;
	} else {
		isAuthenticatedUser = true;
	}

	// Text Values from the nodes on the HTML
	const resultsTableTextValues = document.getElementById('petrol-prices-result-table'),
		// Text/Links for the Results Table and its columns.
		resultsTablePricePerLitre = resultsTableTextValues.dataset.resultstablepriceperlitre,
		resultsTableDistance = resultsTableTextValues.dataset.resultstabledistance,
		resultsTableLocation = resultsTableTextValues.dataset.resultstablelocation,
		resultsTableFillUpToSave = resultsTableTextValues.dataset.resultstablefilluptosave,
		resultsTableFillUpToSaveNoSaving = resultsTableTextValues.dataset.resultstablefilluptosavenosaving,
		resultsTablePricesUpdated = resultsTableTextValues.dataset.resultstablepricesupdated,
		// Reintroduced in v3
		// resultsTableOpeningTimes = resultsTableTextValues.dataset.resultstableopeningtimes,
		// resultsTableOpeningTimes24Hrs = resultsTableTextValues.dataset.resultstableopeningtimes24hrs,
		// resultsTablePriceOpeningTimesNow = resultsTableTextValues.dataset.resultstablepriceopeningtimesnow,
		resultsTableGetDirectionsText = resultsTableTextValues.dataset.resultstablegetdirectionstext,
		resultsTablePriceCheapest = resultsTableTextValues.dataset.resultstablepricecheapest;

	function init() {
		getPriceStatistics(priceStatisticsUrl);
		setupEventListeners();

		const urlParams = new URLSearchParams(window.location.search);
		const postcode = urlParams.get('postcode');
		const fuelType = urlParams.get('fuelType');
		const sortType = urlParams.get('sortType');
		const radius = urlParams.get('radius');

		const radiusSelect = document.getElementsByName('searchRadius');
		const sortSelect = document.getElementsByName('sortBy');

		if (postcode && fuelType && sortType && radius) {
			// User is coming from a shared link
			document.getElementById('petrolPricesPostcode').value = postcode;
			selectedFuelType = fuelType;

			const fuelTypeMap = {
				1: 'fuelTypeSelect-SuperUnleaded',
				2: 'fuelTypeSelect-Petrol',
				6: 'fuelTypeSelect-Diesel',
			};
			const selectedFuelTypeId = fuelTypeMap[fuelType];
			if (selectedFuelTypeId) document.getElementById(selectedFuelTypeId).checked = true;
			sortType == 'price' ? (sortSelect[0].checked = true) : (sortSelect[1].checked = true);

			if (radius == 5) {
				radiusSelect[0].checked = true;
			} else if (radius == 10) {
				radiusSelect[1].checked = true;
			} else {
				radiusSelect[2].checked = true;
			}

			document.getElementById('usePostCode').click();
			document.getElementById('updatePrices').click();
		} else {
			// Setting Initial Checked for Fuel Types and Radius.
			setFuelTypes(null, 'initial');
			radiusSelect[0].checked = true;
			sortSelect[0].checked = true;
		}
	}

	function initMap() {
		if ('geolocation' in navigator) {
			// If geolocation is available
			navigator.geolocation.getCurrentPosition(
				function (position) {
					// Retrieve the user's latitude and longitude
					const latitude = position.coords.latitude,
						longitude = position.coords.longitude,
						geocoder = new google.maps.Geocoder();

					const latlng = { lat: latitude, lng: longitude };

					// Get this to be a PostCode
					geocoder.geocode({ location: latlng }, (results, status) => {
						if (status === 'OK') {
							if (results[0]) {
								for (let i = 0; i < results[0].address_components.length; i++) {
									const component = results[0].address_components[i];
									if (component.types.includes('postal_code')) {
										const postalCode = component.short_name;
										// Display the location result
										const postCodeInput = document.getElementById('petrolPricesPostcode'),
											postcodeInputSort = document.getElementById('petrolPricesPostcodeSort');
										setPostCode(postCodeInput, postalCode);
										setPostCode(postcodeInputSort, postalCode);
									}
								}
							} else {
								errorValidation(getLocationButton);
							}
						} else {
							console.log(`Geocoder failed due to: ${status}`);
							errorValidation(getLocationButton);
						}
					});
				},
				function (error) {
					// Handle any errors that occur
					console.log(`Geocoder failed due to: ${error}`);
					errorValidation(getLocationButton);
				}
			);
		} else {
			errorValidation(getLocationButton);
		}
	}

	if (shareButton) {
		shareButton.addEventListener('click', async function () {
			const postcodeInput = document.getElementById('petrolPricesPostcode');
			const postcode = postcodeInput.value;
			if (postcode == '' || !postcode) return;

			const baseURL = window.location.origin + window.location.pathname;
			const shareLink = `${baseURL}?postcode=${encodeURIComponent(postcode)}&fuelType=${selectedFuelType}&sortType=${sortType}&radius=${radius}`;

			if (navigator.share) {
				try {
					await navigator.share({
						title: 'Confused.com Petrol Prices',
						text: 'The best place to get the cheapest petrol prices near you',
						url: shareLink,
					});
				} catch (error) {
					console.error(`Error sharing link: ${error}`);
				}
			} else {
				navigator.clipboard
					.writeText(shareLink)
					.then(function () {
						const copiedMessage = document.getElementById('copied-message');
						if (!copiedMessage) return;

						setTimeout(() => {
							copiedMessage.classList.add('show');
							copiedMessage.setAttribute('aria-hidden', 'false');
						}, 100);

						setTimeout(() => {
							copiedMessage.classList.remove('show');
							copiedMessage.setAttribute('aria-hidden', 'true');
						}, 3000);
					})
					.catch(function (error) {
						console.error('Failed to copy text: ', error);
					});
			}
		});
	}

	getLocationButton.addEventListener('click', function () {
		initMap();
	});

	openFilters.addEventListener('click', function (e) {
		e.preventDefault();
		parent.classList.add('show-filters-parent');
		filter.classList.add('show-filters-child');
	});

	closedFilters.addEventListener('click', function (e) {
		e.preventDefault();
		parent.classList.remove('show-filters-parent');
		filter.classList.remove('show-filters-child');
	});

	// Close the menu when clicking on the shadowed area
	document.getElementById('filter').addEventListener('click', function (event) {
		// Check if the click occurred on the ::before pseudo-element
		if (event.target === document.getElementById('filter')) {
			parent.classList.remove('show-filters-parent');
			filter.classList.remove('show-filters-child');
		}
	});

	// GET GENERALISED PRICE STATISTICS FROM GETPRICESTATISTICS API
	async function getPriceStatistics(priceStatisticsUrl) {
		try {
			const res = await sGetFromEngagementTools(apiSubKey, priceStatisticsUrl);
			if (!res.ok) throw new Error(res.status);
			const priceStatsJsonData = await res.json();
			displayPriceStatisticsData(priceStatsJsonData);
		} catch (error) {
			console.error('Error:', error);
		}
	}

	// USING THE PARSED JSON DATA, BUILD HTML FOR TABLE TO DISPLAY DATA
	const displayPriceStatisticsData = priceStatsJsonData => {
		const pricesTable = document.querySelector('.petrol-prices__table'),
			lastUpdatedDate = document.querySelector('.prices-updated'),
			genericTextValues = document.getElementById('petrol-prices-generic-text'),
			options = { day: '2-digit', month: 'long', year: 'numeric' },
			averageText = genericTextValues.dataset.average,
			lowestText = genericTextValues.dataset.lowest,
			highestText = genericTextValues.dataset.highest,
			petrolText = genericTextValues.dataset.petrol,
			dieselText = genericTextValues.dataset.diesel,
			updatedTextBeginning = genericTextValues.dataset.updatedtextbeginning,
			updatedTextEnd = genericTextValues.dataset.updatedtextend;
		let updatedText = '',
			fuelPricesHTML = '',
			date = new Date(priceStatsJsonData.lastUpdated);

		updatedText = `<p >${updatedTextBeginning}<span class="bold">${date.toLocaleDateString('en-GB', options)}</span>${updatedTextEnd}</p>`;

		priceStatsJsonData.fuelPrices.forEach(function (fuelPrice) {
			fuelPricesHTML += `
			<tr class="mobile-only">
				<th colspan="3">${fuelPrice.fuelType === 6 ? dieselText : petrolText}</th>
			</tr>
			<tr>
				<th><div>${fuelPrice.fuelType === 6 ? dieselText : petrolText}</div></th>
				<td><div>${fuelPrice.average}p</div></td>
				<td><div>${fuelPrice.lowest}p</div></td>
				<td><div>${fuelPrice.highest}p</div></td>
			</tr>
			`;
		});

		const tableHTML = `
			<table class="cms-table cms-table--compare cms-table--compare-x3 fuel-price-comparison-table">
				<thead>
				<tr>
					<th>&nbsp;</th>
					<th>${averageText}</th>
					<th>${lowestText}</th>
					<th>${highestText}</th>
				</tr>
				</thead>
				<tbody>
					${fuelPricesHTML}
				</tbody>
			</table>	
		`;

		lastUpdatedDate.innerHTML = updatedText;
		pricesTable.innerHTML = tableHTML;
	};

	// SET UP EVENT LISTENERS FOR CLICK & CHANGE FUNCTIONS ON EXISTING HTML ELEMENTS
	const setupEventListeners = () => {
		const getPricesWithPostCodeButton = document.getElementById('usePostCode'),
			updatePricesButton = document.getElementById('updatePrices'),
			postcodeInput = document.getElementById('petrolPricesPostcode'),
			petrolPricesForm = document.getElementById('petrol-prices-form'),
			petrolPricesResults = document.getElementById('petrol-prices-results'),
			postcodeInputSort = document.getElementById('petrolPricesPostcodeSort');

		getPricesWithPostCodeButton.addEventListener('click', event => {
			event.preventDefault();
			resetValues();
			scrollToTop();

			if (errorValidation(postcodeInput)) {
				selectedPostCode = postcodeInput.value.replace(/\s+/g, '');
				selectedFuelType = setFuelTypes(selectedFuelType, 'search');
				setPostCode(postcodeInputSort, selectedPostCode);

				if (selectedFuelType != '' && selectedPostCode != '' && radius != '') {
					pushGAEvent(getPricesWithPostCodeButton, 'search', true, selectedPostCode, selectedFuelType);
					loadStationsPricesJSON(selectedPostCode, selectedFuelType, radius, 5);
				}
			}
		});

		updatePricesButton.addEventListener('click', event => {
			event.preventDefault();
			resetValues();
			scrollToTop();

			if (errorValidation(postcodeInputSort)) {
				selectedPostCode = postcodeInputSort.value.replace(/\s+/g, '');
				selectedFuelType = setFuelTypes(selectedFuelType, false);
				setPostCode(postcodeInputSort, selectedPostCode);
				radius = setRadius(radius);
				const sort = setSort(sortType);
				// To be reintroduced in v3
				// const openStations = document.getElementById('filterOnlyOpenCheckbox').checked;

				if (selectedFuelType != '' && selectedPostCode != '' && radius != '') {
					pushGAEvent(
						getPricesWithPostCodeButton,
						'filter',
						true,
						selectedPostCode,
						selectedFuelType,
						radius,
						sort,
						false
					);
					loadStationsPricesJSON(selectedPostCode, selectedFuelType, radius, 5);
				}
			}

			parent.classList.remove('show-filters-parent');
			filter.classList.remove('show-filters-child');
		});

		viewMoreButton.addEventListener('click', function (e) {
			e.preventDefault();
			resetValues();
			scrollToTop();

			if (errorValidation(postcodeInput)) {
				selectedPostCode = postcodeInput.value.replace(/\s+/g, '');
				selectedFuelType = setFuelTypes(selectedFuelType, false);
				setPostCode(postcodeInputSort, selectedPostCode);
				radius = setRadius(radius, 'expand');

				if (selectedFuelType != '' && selectedPostCode != '' && radius != '') {
					loadStationsPricesJSON(selectedPostCode, selectedFuelType, radius, 10);
				}
			}
		});
	};

	// FETCH PETROL PRICE DATA FROM API
	async function loadStationsPricesJSON(selectedPostCode, selectedFuelType, radius, pageSize) {
		let radiusVal = radius.toString(),
			requestPayload = {
				FuelType: selectedFuelType,
				Radius: radiusVal,
				Postcode: selectedPostCode,
				PostcodeLatitude: (geoLat = null),
				PostcodeLongitude: (geoLong = null),
				RequestSource: requestSource,
			},
			petrolPriceJsonData = [],
			filterOnlyOpenCheckbox = false,
			authCookie = 'AuthPrompt',
			postcodeInput = document.getElementById('petrolPricesPostcode'),
			postcodeInputSort = document.getElementById('petrolPricesPostcodeSort'),
			petrolPricesForm = document.getElementById('petrol-prices-form'),
			petrolPricesResults = document.getElementById('petrol-prices-results');

		sortType = setSort(sortType);
		try {
			const { lat, long } = await getLatLng(selectedPostCode);
			// Use lat and long here as geoLat and geoLong
			geoLat = lat;
			geoLong = long;
		} catch (error) {
			console.error('Error:', error);
			errorValidation(postcodeInput, true);
			errorValidation(postcodeInputSort, true);
			return;
		}

		const apiPetrol = `${petrolPricesUrl}?lat=${geoLat}&long=${geoLong}&fuelType=${selectedFuelType}&radius=${radiusVal}&pageSize=${pageSize}&sortBy=${sortType}`;

		// Authentication stuff for the logged out user.
		console.log('isAuthenticatedUser', isAuthenticatedUser);
		if (isAuthenticatedUser === false) {
			// Checking if Cookie Exists
			if (cookieExists(authCookie)) {
				// Setting the value on the payload
				requestPayload.UnauthenticatedUserPricesNumberOfRequests = '1';
			} else {
				// Creating the Cookie
				setSessionCookie(authCookie, `0 ${selectedPostCode}`);
			}
		} else {
			// If logged in remove the cookie.
			if (cookieExists(authCookie)) {
				deleteCookie(authCookie);
			}
		}

		requestPayload = JSON.stringify(requestPayload);

		try {
			const res = await sGetFromEngagementTools(apiSubKey, apiPetrol);
			if (!res.ok) throw new Error(res.status);

			const petrolPriceJsonData = await res.json();
			const parsedPetrolPriceData = petrolPriceJsonData.stations;

			sortedPetrolPriceData = sortPetrolPriceData(parsedPetrolPriceData, sortType, sortedPetrolPriceData);
			displayData = filterData(filterOnlyOpenCheckbox, sortedPetrolPriceData, displayData);

			(async () => {
				geoLocation = await getLatLng(selectedPostCode);
				if (selectedPostCode && selectedFuelType) {
					petrolPricesResults.classList.remove('display-none');
					petrolPricesForm.classList.add('display-none');
				}

				if (isAuthenticatedUser === true) {
					if (petrolPriceJsonData.IsAuthenticatedUserPricesRequestsCapped === true) {
						exceededLookups(container);
					} else if (
						(Array.isArray(parsedPetrolPriceData) && parsedPetrolPriceData.length === 0) ||
						parsedPetrolPriceData[0].CategoryNumber === 0
					) {
						noResultsFound(container, true);
					} else {
						displayPetrolPriceData(displayData, petrolPriceJsonData);
					}
				} else {
					if (petrolPriceJsonData.IsUnauthenticatedUserPricesRequestsCapped === true) {
						needToLogInView(container);
					} else if (
						(Array.isArray(parsedPetrolPriceData) && parsedPetrolPriceData.length === 0) ||
						parsedPetrolPriceData[0].CategoryNumber === 0
					) {
						noResultsFound(container, false);
					} else {
						displayPetrolPriceData(displayData, petrolPriceJsonData);
					}
				}
			})();

			switch (radiusVal) {
				case '5':
					if (petrolPriceJsonData.NumberOfPricesWithin10Miles < 0) {
						viewMoreButton.classList.add('visually-hidden');
					} else {
						viewMoreButton.classList.remove('visually-hidden');
					}
					break;
				case '10':
					if (petrolPriceJsonData.NumberOfPricesWithin25Miles < 0) {
						viewMoreButton.classList.add('visually-hidden');
					} else {
						viewMoreButton.classList.remove('visually-hidden');
					}
					break;
				case '25':
					viewMoreButton.classList.add('visually-hidden');
					break;
				default:
					break;
			}
		} catch (error) {
			console.error('Error:', error);
			apiError(container);
		}
	}

	// HANDLE DISPLAYING THE DATA - LOOP THROUGH EACH RESULT & BUILD UP CARD HTML
	// 2 CARD TYPES, CHEAPEST & NEAREST WITH ADDITIONAL CARDS FOR LOGIN AND SHOW MORE
	async function displayPetrolPriceData(displayData, petrolPriceJsonData) {
		const list = document.querySelector('.petrol-prices__results-list');
		const newListNode = document.createElement('div');
		newListNode.classList.add('petrol-prices__results-list');
		const headerNode = document.getElementById('petrol-prices-rewards-text').content;
		const loginRequestNode = document.getElementById('petrol-prices-login-or-register').content;
		const petrolPricesResultsRow = document.getElementById('petrol-prices-results-row').content;
		const petrolPricesResultsRowDetails = document.getElementById('petrol-prices-results-row-details').content;

		const cheapestIndicator = document.createElement('div');
		cheapestIndicator.classList.add('cheapest--indicator');

		//- Have to determine the cheapest now ourselves. Mapping the prices to see the highest and the lowest prices
		const prices = displayData.map(displayData => displayData.price);
		const highestPrice = Math.max(...prices);
		const lowestPrice = Math.min(...prices);

		//- To add the rewards banner.
		displayData.splice(2, 0, '');

		for (const [i, stn] of displayData.entries()) {
			//- To fill in the fill up to save function.
			const priceDifference = (highestPrice - stn.price) / 100;
			const multipliedResult = priceDifference * 50;
			let fillUpToSave = `£${multipliedResult.toFixed(2)}`;
			if (priceDifference === 0) {
				fillUpToSave = `${resultsTableFillUpToSaveNoSaving}`;
			}

			//- Determining the ranking of the results. Checking if the prices of the results is equal to the lowest to display the cheapest banner.
			let ranking;
			if (stn.price === lowestPrice) {
				ranking = 1;
			}

			//REPLACE WITH NODES WHEN IN F
			if (displayData.length === 2 ? i == 1 : i == 2) {
				newListNode.appendChild(headerNode.cloneNode(true));
			} else if (stn.CategoryNumber !== 0 && stn.SiteName !== null && i !== 2) {
				//- Making sure the lat and long are used in the googlemaps url. To be replaced with data in the API eventually.
				let directionsLink = document.createElement('span');
				if (!geoLocationError) {
					directionsLink = document.createElement('a');
					directionsLink.href = `https://www.google.com/maps/dir/?api=1&travelmode=driving&dir_action=navigate&origin=${geoLocation.lat},${geoLocation.long}&destination=${stn.latitude},${stn.longitude}`;
					directionsLink.classList.add('directions-link');
					directionsLink.target = '_blank';
					directionsLink.rel = 'noopener noreferrer nofollow';
					directionsLink.textContent = resultsTableGetDirectionsText;
				}

				if (!isAuthenticatedUser && i !== 0 && i !== 2) {
					const petrolPricesResultsRowNode = getBasePetrolPriceResultsRow(i, stn, resultsTablePricePerLitre);
					appendLoginRequestNode(petrolPricesResultsRowNode);
					appendCheapestIndicator(petrolPricesResultsRowNode, ranking);

					newListNode.appendChild(petrolPricesResultsRowNode);
				} else {
					const petrolPricesResultsRowNode = getBasePetrolPriceResultsRow(i, stn, resultsTablePricePerLitre);
					appendPetrolPricesResultDetails(
						petrolPricesResultsRowNode,
						resultsTableLocation,
						stn,
						directionsLink,
						resultsTableDistance,
						resultsTableFillUpToSave,
						fillUpToSave,
						resultsTablePricesUpdated
					);
					appendCheapestIndicator(petrolPricesResultsRowNode, ranking);

					newListNode.appendChild(petrolPricesResultsRowNode);
				}
			} else {
				if (petrolPriceJsonData.IsAuthenticatedUser === false) {
					const petrolPricesResultsRowNode = getBasePetrolPriceResultsRow(i, stn, ranking);
					appendLoginRequestNode(petrolPricesResultsRowNode);
					appendCheapestIndicator(petrolPricesResultsRowNode, ranking);

					newListNode.appendChild(petrolPricesResultsRowNode);
				}
			}
		}

		if (isAuthenticatedUser) {
			const filter = document.querySelector('.petrol-prices__sort-filter');
			filter.classList.remove('visually-hidden');
		} else {
			openFilters.classList.add('visually-hidden');
			viewMoreButton.classList.add('visually-hidden');
			const filter = document.getElementById('filterNotLoggedIn');
			filter.classList.remove('visually-hidden');
		}

		list.replaceWith(newListNode);

		function getBasePetrolPriceResultsRow(i, stn, resultsTablePricePerLitre) {
			const petrolPricesResultsRowNode = petrolPricesResultsRow
				.cloneNode(true)
				.querySelector('.petrol-prices__results-row');
			petrolPricesResultsRowNode.id = `priceResult-${i}`;
			petrolPricesResultsRowNode.querySelector('.results-row__title').textContent = resultsTablePricePerLitre;
			petrolPricesResultsRowNode.querySelector('.results-row__value').textContent = `${stn.price.toFixed(1)}p`;
			return petrolPricesResultsRowNode;
		}

		function appendCheapestIndicator(petrolPricesResultsRowNode, ranking) {
			if (ranking === 1) {
				petrolPricesResultsRowNode.classList.add('cheapest');

				const cheapestIndicatorNode = cheapestIndicator.cloneNode(true);
				cheapestIndicatorNode.textContent = resultsTablePriceCheapest;
				petrolPricesResultsRowNode.appendChild(cheapestIndicatorNode);
			}
		}

		function appendLoginRequestNode(petrolPricesResultsRowNode) {
			const loginRequestNodeClone = loginRequestNode.cloneNode(true);
			petrolPricesResultsRowNode.appendChild(loginRequestNodeClone);
		}

		function appendPetrolPricesResultDetails(
			petrolPricesResultsRowNode,
			resultsTableLocation,
			stn,
			directionLink,
			resultsTableDistance,
			resultsTableFillUpToSave,
			fillUpToSave,
			resultsTablePricesUpdated
		) {
			const petrolPricesResultsRowDetailsNode = petrolPricesResultsRowDetails.cloneNode(true);
			petrolPricesResultsRowDetailsNode.querySelector(
				'span.results-row__title[data-col="table-location"]'
			).textContent = resultsTableLocation;
			petrolPricesResultsRowDetailsNode.querySelector('span.results-row__value[data-col="brand"]').textContent =
				stn.brand;
			petrolPricesResultsRowDetailsNode.querySelector('span.results-row__value[data-col="address"]').textContent =
				stn.address;
			petrolPricesResultsRowDetailsNode.querySelector(
				'span.results-row__value[data-col="postcode"]'
			).textContent = stn.postcode;
			petrolPricesResultsRowDetailsNode
				.querySelector('span.results-row__value[data-col="directions-link"]')
				.appendChild(directionLink);
			petrolPricesResultsRowDetailsNode.querySelector(
				'span.results-row__title[data-col="distance"]'
			).textContent = resultsTableDistance;
			petrolPricesResultsRowDetailsNode.querySelector(
				'span.results-row__value[data-col="distance-miles"]'
			).textContent = `${stn.distanceMiles} Miles`;
			petrolPricesResultsRowDetailsNode.querySelector(
				'span.results-row__title[data-col="table-fill-up-to-save"]'
			).textContent = resultsTableFillUpToSave;
			petrolPricesResultsRowDetailsNode.querySelector(
				'span.results-row__value[data-col="fill-up-to-save"]'
			).textContent = fillUpToSave;
			petrolPricesResultsRowDetailsNode.querySelector(
				'span.results-row__title[data-col="table-prices-updated"]'
			).textContent = resultsTablePricesUpdated;
			petrolPricesResultsRowDetailsNode.querySelector(
				'span.results-row__value[data-col="last-updated"]'
			).textContent = formatDate(stn.lastUpdated);

			petrolPricesResultsRowNode.appendChild(petrolPricesResultsRowDetailsNode);
		}
	}

	async function pushGAEvent(
		input,
		inputType = '',
		validation = false,
		postcode,
		fuelType,
		searchRadius,
		sortBy,
		openStations
	) {
		if (typeof dataLayer === 'undefined') {
			// DataLayer is not defined
			// You can handle this situation here
			alert('no dataLayer');
		} else {
			// DataLayer exists and is defined
			// You can work with the dataLayer here
			let payload = {};

			switch (inputType) {
				case 'search':
					payload = {
						event: 'continue',
						continueValidation: validation,
						continueValidationErrors: collateErrorMessages(),
						elementId: input.getAttribute('id'),
						formId: input.form.getAttribute('id'),
						postcode: postcode,
						fuelType: fuelType,
						searchRadius: '5',
					};
					break;
				case 'filter':
					payload = {
						event: 'continue',
						continueValidation: validation,
						continueValidationErrors: collateErrorMessages(),
						elementId: input.getAttribute('id'),
						formId: input.form.getAttribute('id'),
						postcode: postcode,
						fuelType: fuelType,
						searchRadius: searchRadius,
						sortBy: sortBy,
						openStationsOnly: openStations,
					};
			}

			dataLayer.push(payload);

			console.log(dataLayer);
		}
	}

	function collateErrorMessages() {
		let continueValidationErrors = '';
		const errors = document.querySelectorAll('.field-group--error');

		errors.forEach(error => {
			const errorMessage = error.querySelector('.error-message');
			continueValidationErrors += `${errorMessage.innerHTML};`;
		});
		return continueValidationErrors;
	}

	return {
		init: init,
	};
})();

document.addEventListener('DOMContentLoaded', function () {
	petrolPrices.init();
	setupShowMoreOptions();
});
